<template>
  <div class="card">
    <div class="card-content">
      <div class="level is-middle">
        <div class="level-left">
          <div>
            <slot name="title">
              <div>
                {{ title }}
              </div>
            </slot>
          </div>
        </div>

        <div class="level-right">
          <div>
            <slot></slot>
          </div>
        </div>
      </div>

      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"]
};
</script>
